/**
 * a recursive function that maps rules' fields to information in the scenario fields. 
 * The function will map min and max fields and get the fields' human readable names from the scenario fields
 * 
 * @param field a QuickQuote rule's field
 * @param {*} fields list of scenario fields. will be reduced to the children of a parent on recursion
 * @param rule the rule that is having it's fields formatted. used to return useful error information
 * @returns a rule's field with the correct name and param values
 */
export function getDisplayableRuleInfo(field, fields, rule) {
	let scenarioField = fields.find((f) => f.param === field.name);
	// get the first three letters of the field name to check if it is a max or min value from a compensating factor
	const substring = field.name.substring(0,3)
	// variable to store the substring if it was max or min
	let maxMin = '';

	// if a field is not found in the scenario but the first three letters of the current field name are 'max' or 'min'
	if (scenarioField === undefined && (substring === 'max' || substring === 'min')) {
		// get the actual field name by cutting off the first 3 letters and setting the 4th letter to lowercase
		const fieldName = field.name.substring(3,).charAt(0).toLowerCase() + field.name.slice(4);
		// try to find a field in the scenario with the actual field name
		scenarioField = fields.find((f) => f.param === fieldName);
		// capitalize the max or min string and store it in a variable
		maxMin = substring.charAt(0).toUpperCase() + substring.slice(1) + ' ';
	}

	if (scenarioField === undefined) {
		// don't try to loop down because it can't be done with an undefined scenarioField
		// a field was not found so set the maxMin holder back to an empty string
		maxMin = '';

		// convert field from camel case to Sentence case
		const result = field.name.replace(/([A-Z])/g,' $1');
		const final = result.charAt(0).toUpperCase() + result.slice(1);
		field["param"] = field.name;
		field["name"] = final;
		// make it noticable that the field failed
		field["value"]  = 'Error. Field not found';
		// fail the rule
		field["valid"] = false;

		// TODO: replace console.error with azure insight
		if (field.name === 'Error') {
			// the rule did not evaluate correctly
			console.error(`Rule "${rule.name}" was not evaluated correctly check QuickQuote for more details.`)
		} else {
			// the rule evaluated correctly but couldn't find the field
			console.error(`In rule "${rule.name}" the field "${field.name}" is not a valid field.`);
		}
	} else {
		// if the scenario field has objects
		if (scenarioField.objects) {
			// array to hold the children of the current field
			const results = [];
			// for each child of the field
			for (let child of field.children) {
				// get the name of the field by re-calling the function
				results.push(getDisplayableRuleInfo(child, scenarioField.objects, rule));
			}
			// set the field's value to be the results of the function
			field["children"] = results;
		}
		// set the param and name field variables with the desired values. Add max or min to the front of the scenario field name if present
		field["param"] = field.name;
		field["name"] = maxMin + scenarioField.name;
	}
	return field;
}